// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import Tooltip from "rc-tooltip";
import ReactHtmlParser from "react-html-parser";

// Css Imports
// NOTE: rc-tooltip bootstrap + our overrides are imported globally via src/index.scss -> src/revvComponents/index.scss

const ToolTipWrapper = props => {
  const { children, imgAltTxt, imgUrl, overlay, placement, ...otherProps } =
    props;

  // Tooltip with image option
  if (imgUrl) {
    return (
      <Tooltip
        data-test="tooltip"
        overlayClassName="rc-tooltip-img"
        overlay={ReactHtmlParser(
          `
          <div class="rc-tooltip-overlay">
            <img src=${imgUrl} alt=${imgAltTxt} style={{width: 100%}}/>${overlay}
          </div>
        `,
        )}
        placement={placement}
        mouseLeaveDelay={0}
        {...otherProps}>
        {children}
      </Tooltip>
    );
  }

  // Tooltip with only text
  return (
    <Tooltip
      data-test="tooltip"
      placement={placement}
      overlay={overlay}
      mouseLeaveDelay={0}
      {...otherProps}>
      {children}
    </Tooltip>
  );
};

ToolTipWrapper.defaultProps = {
  children: "",
  imgAltTxt: "",
  imgUrl: "",
  placement: "top",
};

ToolTipWrapper.propTypes = {
  placement: PropTypes.string,
  children: PropTypes.node,
  overlay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]).isRequired,
  imgAltTxt: PropTypes.string,
  imgUrl: PropTypes.string,
};

export default ToolTipWrapper;
